import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditarFuncionarioLayer from "../components/EditarFuncionarioLayer";
import { useTranslation } from "../i18n/I18nContext";

const EditarFuncionarioPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("funcionario.breadcrumb.edit")} />
      <EditarFuncionarioLayer />
    </MasterLayout>
  );
};

export default EditarFuncionarioPage;
